module.exports = __webpack_public_path__ + "static/media/challenge-banner-nick.e7b15826.png";